const getUniqueProdIds = (data) => {
  const idSums = {};

  data.forEach((item) => {
    const id = item.id;
    const quantity = item.sales_count;

    if (idSums[id]) {
      idSums[id] += quantity;
    } else {
      idSums[id] = quantity;
    }
  });

  return idSums;
};

export default getUniqueProdIds;
